import { render, staticRenderFns } from "./schoolAndDate.vue?vue&type=template&id=74da7cb7&scoped=true&"
import script from "./schoolAndDate.vue?vue&type=script&lang=js&"
export * from "./schoolAndDate.vue?vue&type=script&lang=js&"
import style0 from "./schoolAndDate.vue?vue&type=style&index=0&id=74da7cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da7cb7",
  null
  
)

export default component.exports